import axios from 'axios'
import { ihConfigUrl } from '@/api/config'
import {errorCollection} from "@/api/dmp/dmpCollection";

/**
 * 获取签名
 *
 */
export function getUserSig(params) {
  const url = ihConfigUrl + `/rtc/getUserSig`
  return axios({
    method: 'get',
    url: url,
    params: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('实时监控', '获取trtc签名', res)
    }
    return Promise.resolve(res.data)
  })
}
